
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-white border-t" style={{borderTopColor: 'var(--brand-primary)', backgroundColor: 'var(--footer-bg)'}} dir="rtl">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-10 w-10 rounded-full flex items-center justify-center" style={{backgroundColor: 'var(--brand-primary)'}}>
                {/* <span className="text-white font-bold text-lg">S</span> */}
                {/* Logo */}
					<Link to='/' className='flex items-center'>
						<img 
							src="./logo.png" 
							alt="SHA-SHA By Nataly" 
							className="h-10 min-w-12 sm:h-12 md:h-14 lg:h-16 xl:h-20 bg-white drop-shadow-sm hover:drop-shadow-md transition-all rounded-2xl duration-300"
						/>
					</Link>
              </div>
              <span className="text-xl font-bold" style={{color: 'var(--brand-primary)'}}>
                SHA-SHA
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              תכשיטים בעבודת יד עם אבני חן טבעיות. כל תכשיט מספר סיפור ייחודי ומביא איתו אנרגיה חיובית.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <span>🏆</span>
              <span>מעל 1000 לקוחות מרוצים</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{color: 'var(--brand-primary)'}}>קישורים מהירים</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  דף הבית
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  אודות
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  צור קשר
                </Link>
              </li>
              <li>
                <Link to="/cart" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  עגלת קניות
                </Link>
              </li>
              <li>
                <Link to="/wishlist" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  רשימת המשאלות
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                   לוח בקרה
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{color: 'var(--brand-primary)'}}>קטגוריות</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/category/necklaces" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  שרשראות
                </Link>
              </li>
              <li>
                <Link to="/category/earrings" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  עגילים
                </Link>
              </li>
              <li>
                <Link to="/category/bracelets" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  צמידים
                </Link>
              </li>
              <li className="mr-4">
                <Link to="/category/bracelets?subcategory=mens" className="text-gray-500 text-brand-primary-hover transition-colors text-xs">
                  • צמיד לגבר
                </Link>
              </li>
              <li className="mr-4">
                <Link to="/category/bracelets?subcategory=blackened" className="text-gray-500 text-brand-primary-hover transition-colors text-xs">
                  • צמיד מושחר
                </Link>
              </li>
              <li>
                <Link to="/category/rings" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  טבעות
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-500 text-brand-primary-hover transition-colors text-sm">
                  מבצעים
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media & Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{color: 'var(--brand-primary)'}}>עקבו אחרינו</h3>
            <div className="flex space-x-4 space-x-reverse mb-4">
              <a href="https://www.facebook.com/profile.php?id=61556765813584&ref=_ig_profile_ac" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-brand-primary-hover transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 30 24" style={{backgroundColor: 'var(--brand-primary)'}}>
                <path className="fill-current text-brand-primary" d="M23,31H9c-4.4,0-8-3.6-8-8V9c0-4.4,3.6-8,8-8h14c4.4,0,8,3.6,8,8v14C31,27.4,27.4,31,23,31z"/>
                <path className="fill-current text-white" d="M26,16h-5v-2.8c0-0.7,0.5-1.2,1.2-1.2H25V7h-4h0c-2.8,0-5,2.2-5,5v0v4h-4v5h4v10h5V21h3L26,16z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/shasha_jewelery/" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-brand-primary-hover transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@shasha_jewelry?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-brand-primary-hover transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-tiktok w-6 h-6" viewBox="0 0 16 16">
                  <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
                </svg>

              </a>
              {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-brand-primary-hover transition-colors">
                <svg className="w-6 h-6" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                 <path d="M 10 10 L 90 90 M 90 10 L 10 90" stroke="black" stroke-width="5" fill="none"/>
                </svg>
              </a> */}
                  {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-brand-primary-hover transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.097.118.112.22.083.402-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/>
                </svg>
              </a> */}
              <a href="https://wa.me/97254053-3332127" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-brand-primary-hover transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.992c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z"/>
                </svg>
              </a>
            </div>
            
            {/* Newsletter Signup */}
            <div className="mb-4">
              <h4 className="text-sm font-medium mb-2 text-gray-300">הירשמו לעדכונים</h4>
              <div className="flex">
              <button className="px-4 py-2 text-white rounded-r-lg transition-all duration-300 text-sm" style={{backgroundColor: 'var(--brand-primary)'}} >
                  הרשמה
                </button>
                <input
                  type="email"
                  placeholder="דואר אלקטרוני"
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 text-sm"
                  style={{outlineColor: 'var(--brand-primary)', boxShadow: '0 0 0 2px var(--brand-primary-light)'}}
                />
                
              </div>
              <p className="text-xs text-gray-500 mt-1">
                קבלו הודעות על מבצעים, קולקציות חדשות וקופונים בלעדיים
              </p>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{color: 'var(--brand-primary)'}}>צריכים עזרה?</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <span>📞</span>
                <span>שירות לקוחות:053-3332127</span>
              </div>
              <div className="flex items-center gap-2">
                <span>📧</span>
                <span>nataly@sha-sha.co.il</span>
              </div>
              <div className="flex items-center gap-2">
                <span>🕐</span>
                <span>א׳-ה׳: 9:00-18:00, ו׳: 9:00-14:00</span>
              </div>
              <div className="flex items-center gap-2">
                <span>🚚</span>
                <span>משלוח חינם מעל 299₪</span>
              </div>
              <div className="flex items-center gap-2">
                <span>🔄</span>
                <span>החזרות עד 14 יום</span>
              </div>
            </div>
            
            {/* Developer Info */}
            <div className="mt-6 pt-4 border-t border-gray-700">
              <h4 className="text-sm font-medium mb-2" style={{color: 'var(--brand-primary)'}}>פותח על ידי</h4>
              <div className="space-y-1 text-xs text-gray-500">
                <div className="flex items-center gap-2">
                  <span>🏢</span>
                  <span>AWDP - Advanced Web Development Programming</span>
                </div>
                <div className="flex items-center gap-2">
                  <span>👤</span>
                  <span>Ben Ami Izrayev</span>
                </div>
                <div className="flex items-center gap-2">
                  <span>📧</span>
                  <a href="mailto:ben@awdp.co.il" className="hover:text-brand-primary">ben@awdp.co.il</a>
                </div>
                <div className="flex items-center gap-2">
                  <span>📱</span>
                  <a href="tel:+972524467557" className="hover:text-brand-primary">+972-52-4467557</a>
                </div>
                <div className="flex items-center gap-2">
                  <span>🌐</span>
                  <a href="https://awdp.co.il" target="_blank" rel="noopener noreferrer" className="hover:text-brand-primary">awdp.co.il</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t mt-8 pt-8 flex flex-col md:flex-row justify-between items-center" style={{borderTopColor: 'var(--brand-primary)'}}>
            <div className="text-sm text-gray-400 mb-4 md:mb-0">
            <div>© 2025 SHA-SHA Jewelry. כל הזכויות שמורות.</div>
            <div className="mt-1 text-xs">
              פותח על ידי <a href="https://awdp.co.il" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{color: 'var(--brand-primary)'}}>AWDP - Advanced Web Development Programming</a>
            </div>
          </div>
          <div className="flex space-x-6 space-x-reverse text-sm">
            <Link to="/privacy-policy" className="text-gray-400 text-brand-primary-hover transition-colors">
              מדיניות פרטיות
            </Link>
            <Link to="/terms" className="text-gray-400 text-brand-primary-hover transition-colors">
              תנאי שימוש
            </Link>
            <Link to="/returns" className="text-gray-400 text-brand-primary-hover transition-colors">
              מדיניות החזרות
            </Link>
            <Link to="/shipping-policy" className="text-gray-400 text-brand-primary-hover transition-colors">
              מדיניות משלוחים
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 